<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <section class="bg-gray-50 py-16 md:py-24" id="news">
    <div class="container mx-auto px-6">
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          新闻中心
        </h2>
        <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
        <p class="text-gray-700 max-w-3xl mx-auto">
          了解创达科技的最新动态、行业资讯和技术趋势。
        </p>
      </div>
      <div class="news-list" v-if="!isMobile">
        <div
          v-for="(item, index) in paginatedList"
          :key="index"
          class="news-box"
          @click="getnews(index)"
        >
          <!-- <img :src="../assets/n1.png" alt="新闻图片加载失败" /> -->

          <img :src="item.img" />

          <div class="text-box">
            <h3 class="text-main-box">
              {{ item.title }}
            </h3>
            <p class="text-gray-700 line-clamp-2">
              {{ item.content }}
            </p>
            <p class="text-gray-700 line-clamp-2">
              {{ item.time }}
            </p>
          </div>
        </div>
      </div>
      <div class="news-list-mobile" v-else>
        <div
          v-for="(item, index) in paginatedList"
          :key="index"
          @click="getnews(index)"
        >
          <img :src="item.img" />
          <div class="text-box-mobile">
            <h3 class="text-main-box">
              {{ item.title }}
            </h3>
            <p class="text-gray-700 line-clamp-2">
              {{ item.content }}
            </p>
            <br />
            <p class="text-gray-700 line-clamp-2">
              {{ item.time }}
            </p>
          </div>
        </div>
      </div>
      <!-- 分页器组件 -->
      <div class="pagination">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="page-btn prev"
        >
          上一页
        </button>

        <!-- 动态生成页码按钮 -->
        <button
          v-for="page in totalPages"
          :key="page"
          @click="changePage(page)"
          :class="{ active: currentPage === page }"
          class="page-number"
        >
          {{ page }}
        </button>

        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="page-btn next"
        >
          下一页
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsPage",
  data() {
    return {
      richText: "",
      list: [],
      isMobile: false,
      currentPage: 1, // 当前页码（从1开始）
      pageSize: 9, // 每页显示数量
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkDeviceType);
    this.checkDeviceType();
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
     window.removeEventListener("resize", this.checkDeviceType);
  },
  methods: {
    checkDeviceType() {
      //768
      this.isMobile = !(window.innerWidth >=992);
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.scrollToTop();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        // this.scrollToTop();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        // this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async getList() {
      try {
        const response = await fetch("/list.json"); // 假设你的 JSON 文件在 public 目录下
        const data = await response.json();
        this.list = data; // 将 JSON 数据赋值给 list 数组
        
      } catch (error) {
        //console.error("文件加载失败:", error);
      }
    },
    async getnews(id) {
      this.$router.push({ name: "NewsDetail", params: { id } });
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 500;
    },
  },
  // 添加计算属性（用于分页逻辑）
  computed: {
    // 总页数计算
    totalPages() {
      return Math.ceil(this.list.length / this.pageSize); // 添加 return
    }, // 当前页数据切片
    paginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.list.slice(start, end);
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.list-main-box {
  /* border: 1px solid salmon; */
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new-main-box {
  /* height: 80vh; */
  /* border: 1px solid pink; */
  /* overflow-y:scroll; */
}
.news-list {
  display: grid;
  grid-template-columns: repeat(3, 450px); /* 高度根据内容自动扩展 */
  grid-auto-rows: auto; /* 自适应的行间距和列间距 */
  column-gap: auto;
  row-gap: 25px;
  /* border: 1px solid slateblue; */
  justify-content: space-between;
}
.news-box {
  width: 450px;
  height: 500px;
  overflow: hidden;
  /* border: 1px solid #ccc; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.news-box-mobile {
  border: 1px solid pink;
}
.text-box-mobile {
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  font-size: 14px;
}
.text-box {
  flex: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgb(248, 248, 248);
}
img {
  width: 100%;
  height: 280px;
  object-fit: cover; /* 保持图片比例并覆盖容器 */
  transition: transform 1s ease;

  /* 添加过渡动画 */
}
img:hover {
  transform: scale(1.1); /* 放大图片 */
}
.text-main-box {
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  height: 50px;
  font-weight: bold;
}
.text-main-box:hover {
  color: #d02e2f; /* 鼠标悬停时的颜色 */
}
.text-box p {
  font-size: 16px;
  color: #666666;
  line-height: 25px;
}
.pagination {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 4rem;
  padding: 20px 0;
}
.page-btn {
  @apply px-5 py-2 rounded-lg text-gray-700
transition-colors bg-transparent;
  border: none; /* 移除边框 */
}
.page-btn:hover {
  @apply bg-blue-700 text-white; /* 悬停时背景变蓝，文字变白 */
}
.page-number {
  @apply px-4 py-2 rounded-lg text-gray-700 transition-colors bg-transparent;
}
.page-number:hover {
  @apply bg-blue-700 text-white; /* 悬停时背景变蓝，文字变白
*/
}
.page-number.active {
  @apply bg-blue-700 text-white shadow-md; /*
保持激活状态为蓝色 */
}
</style>
